import { Component, OnInit, Input, SimpleChanges, OnChanges, EventEmitter, Output, Inject, OnDestroy, forwardRef } from '@angular/core';
import { FormGroup, FormControl, Validators} from '@angular/forms';

import { DatexFormControl } from './models/datex-form-control';
import { 
  TextBoxModel, 
  NumberBoxModel, 
  SelectBoxModel, 
  ESelectBoxType,
  DateBoxModel, 
  CheckBoxModel, 
  TextModel, 
  LabelModel, 
  ButtonModel,
  SplitButtonModel,
  SeparatorModel,
  ImageModel,
  DrawModel,
  CodeBoxModel,
  ButtonStyles 
} from './models/control';
import { GridHeaderModel, GridCellModel, GridRowModel, CellStyles, GridContainerStyle, HeaderStyles } from './models/grid'
import { FieldModel } from './models/field'
import { ToolModel } from './models/tool';
import { Styles, ControlContainerStyles } from './models/style';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { isEqual, isNil, set } from 'lodash-es';
import { GridComponent, ELoadingStatus } from './components/grid.component';
import { BaseComponent } from './components/base.component';
import { WorkBook, read as readExcelFile, writeFile as writeExcelFile, utils as excelUtils } from 'xlsx';

import { SharedModule } from './shared.module';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';
import { ExcelMaterialImport_ShellService } from './ExcelMaterialImport.shell.service';
import { ExcelMaterialImport_OperationService } from './ExcelMaterialImport.operation.service';
import { ExcelMaterialImport_DatasourceService } from './ExcelMaterialImport.datasource.index';
import { ExcelMaterialImport_FlowService } from './ExcelMaterialImport.flow.index';
import { ExcelMaterialImport_ReportService } from './ExcelMaterialImport.report.index';
import { ExcelMaterialImport_LocalizationService } from './ExcelMaterialImport.localization.service';
import { ExcelMaterialImport_excel_material_import_grid_ComponentContextService } from './ExcelMaterialImport.excel_material_import_grid.component.context.service';
import { Language } from './localization.service';
import { JobStatus } from './common-interfaces'
import { ApplicationType, ComponentType } from './app-context.service';
import { CleanupLoggerService } from './cleanup.logging.service';
import { $frontendTypes} from './ExcelMaterialImport.frontend.types'
import { $frontendTypes as $types} from './ExcelMaterialImport.frontend.types' 

import { EModalSize, EToasterType, EToasterPosition } from 'wavelength-ui';
import { ExcelMaterialImport_owners_dd_singleComponent } from './ExcelMaterialImport.owners_dd_single.component'
import { ExcelMaterialImport_projects_dd_singleComponent } from './ExcelMaterialImport.projects_dd_single.component'
import { ExcelMaterialImport_material_groups_dd_singleComponent } from './ExcelMaterialImport.material_groups_dd_single.component'
import { ExcelMaterialImport_material_statuses_dd_singleComponent } from './ExcelMaterialImport.material_statuses_dd_single.component'
import { ExcelMaterialImport_yn_dd_singleComponent } from './ExcelMaterialImport.yn_dd_single.component'
import { ExcelMaterialImport_allocation_strategy_dd_singleComponent } from './ExcelMaterialImport.allocation_strategy_dd_single.component'
import { ExcelMaterialImport_storage_category_rules_dd_singleComponent } from './ExcelMaterialImport.storage_category_rules_dd_single.component'
import { ExcelMaterialImport_material_packagings_dd_singleComponent } from './ExcelMaterialImport.material_packagings_dd_single.component'
import { ExcelMaterialImport_measurement_units_dd_singleComponent } from './ExcelMaterialImport.measurement_units_dd_single.component'


interface IExcelMaterialImport_excel_material_import_gridComponentEntity {
  Id?: number, AllocationStrategyId?: number, ControllerTypeId?: number, Description?: string, IsFixedLength?: boolean, IsFixedVolume?: boolean, IsFixedWeight?: boolean, LookupCode?: string, MaterialGroupId?: number, Name?: string, ProjectId?: number, StatusId?: number, StorageCategoryRuleId?: number, Project?: { LookupCode?: string, Name?: string, OwnerId?: number, Owner?: { LookupCode?: string, Name?: string } }, MaterialGroup?: { Name?: string }, Status?: { Name?: string }, AllocationStrategy?: { Name?: string }, StorageCategoryRule?: { Id?: number, Name?: string }, basePackaging?: { MaterialId?: number, PackagingId?: number, DimensionUomId?: number, Height?: number, Length?: number, PalletHigh?: number, PalletTie?: number, ShippingVolume?: number, ShippingWeight?: number, UpcCode?: string, Volume?: number, VolumeUomId?: number, Weight?: number, WeightUomId?: number, Width?: number, Packaging?: { ShortName?: string }, DimensionsUom?: { Short_name?: string }, WeightUom?: { Short_name?: string }, VolumeUom?: { Short_name?: string } }}



class ExcelMaterialImport_excel_material_import_gridComponentRowModel extends GridRowModel {
  grid: ExcelMaterialImport_excel_material_import_gridComponent;
  entity: IExcelMaterialImport_excel_material_import_gridComponentEntity;



 // temporarily put required on all edit controls
  override formGroup = new FormGroup({
    lookupcode_edit: new DatexFormControl(null, { validators: [ Validators.required ], updateOn: 'change' }),
    name_edit: new DatexFormControl(null, { validators: [ Validators.required ], updateOn: 'change' }),
    description_edit: new DatexFormControl(null, { validators: [ Validators.required ], updateOn: 'change' }),
    owner_edit: new DatexFormControl(null, { validators: [ Validators.required ], updateOn: 'change' }),
    project_edit: new DatexFormControl(null, { validators: [ Validators.required ], updateOn: 'change' }),
    group_edit: new DatexFormControl(null, { validators: [ Validators.required ], updateOn: 'change' }),
    status_edit: new DatexFormControl(null, { validators: [ Validators.required ], updateOn: 'change' }),
    lot_controlled_edit: new DatexFormControl(null, { validators: [ Validators.required ], updateOn: 'change' }),
    serial_controlled_edit: new DatexFormControl(null, { validators: [ Validators.required ], updateOn: 'change' }),
    fixed_weight_edit: new DatexFormControl(null, { validators: [ Validators.required ], updateOn: 'change' }),
    fixed_dimension_edit: new DatexFormControl(null, { validators: [ Validators.required ], updateOn: 'change' }),
    fixed_volume_edit: new DatexFormControl(null, { validators: [ Validators.required ], updateOn: 'change' }),
    allocation_strategy_edit: new DatexFormControl(null, { validators: [ Validators.required ], updateOn: 'change' }),
    storage_category_rule_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    base_uom_edit: new DatexFormControl(null, { validators: [ Validators.required ], updateOn: 'change' }),
    base_uom_net_weight_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    base_uom_shipping_weight_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    base_uom_upc_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    base_uom_pallet_tie_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    base_uom_pallet_high_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    base_uom_length_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    base_uom_width_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    base_uom_height_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    base_uom_net_volume_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    base_uom_shipping_volume_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    base_uom_weight_unit_edit: new DatexFormControl(null, { validators: [ Validators.required ], updateOn: 'change' }),
    base_uom_dimension_unit_edit: new DatexFormControl(null, { validators: [ Validators.required ], updateOn: 'change' }),
    base_uom_volume_unit_edit: new DatexFormControl(null, { validators: [ Validators.required ], updateOn: 'change' }),
  });

  override cells = {
    Id: null,
    error: null,
    lookupcode: null,
    name: null,
    description: null,
    owner: null,
    project: null,
    group: null,
    status: null,
    lot_controlled: null,
    serial_controlled: null,
    fixed_weight: null,
    fixed_dimension: null,
    fixed_volume: null,
    allocation_strategy: null,
    storage_category_rule: null,
    base_uom: null,
    base_uom_net_weight: null,
    base_uom_shipping_weight: null,
    base_uom_upc: null,
    base_uom_pallet_tie: null,
    base_uom_pallet_high: null,
    base_uom_length: null,
    base_uom_width: null,
    base_uom_height: null,
    base_uom_net_volume: null,
    base_uom_shipping_volume: null,
    base_uom_weight_unit: null,
    base_uom_dimension_unit: null,
    base_uom_volume_unit: null,
  }

  get $fields_owner_selector_inParams_statusId(): number {
    if (!this.entity) return null; 
    const $row = this;
    const $utils = this.$utils;
    const $grid = this.grid;
    const expr = 1;
    
    return expr;
  }
  get $fields_project_selector_inParams_statusId(): number {
    if (!this.entity) return null; 
    const $row = this;
    const $utils = this.$utils;
    const $grid = this.grid;
    const expr = 1;
    
    return expr;
  }
  get $fields_project_selector_inParams_ownerId(): number {
    if (!this.entity) return null; 
    const $row = this;
    const $utils = this.$utils;
    const $grid = this.grid;
    const expr = $row.cells.owner.editControl.value;
    
    return expr;
  }
  get $fields_base_uom_weight_unit_selector_inParams_typeId(): number {
    if (!this.entity) return null; 
    const $row = this;
    const $utils = this.$utils;
    const $grid = this.grid;
    const expr = 3;
    
    return expr;
  }
  get $fields_base_uom_dimension_unit_selector_inParams_typeId(): number {
    if (!this.entity) return null; 
    const $row = this;
    const $utils = this.$utils;
    const $grid = this.grid;
    const expr = 1;
    
    return expr;
  }
  get $fields_base_uom_volume_unit_selector_inParams_typeId(): number {
    if (!this.entity) return null; 
    const $row = this;
    const $utils = this.$utils;
    const $grid = this.grid;
    const expr = 2;
    
    return expr;
  }


  constructor(
    grid: ExcelMaterialImport_excel_material_import_gridComponent,
    private $utils: UtilsService,
private $settings: SettingsValuesService,
private $shell: ExcelMaterialImport_ShellService,
private $datasources: ExcelMaterialImport_DatasourceService,
private $flows: ExcelMaterialImport_FlowService,
private $reports: ExcelMaterialImport_ReportService,
private $localization: ExcelMaterialImport_LocalizationService,
private $operations: ExcelMaterialImport_OperationService,
private $logger: CleanupLoggerService,
private $context: ExcelMaterialImport_excel_material_import_grid_ComponentContextService,
) {
    super();

    this.grid = grid;

    this.cells.Id = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.Id,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.error = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.error,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.lookupcode = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.lookupcode,
      new TextModel(null, null, null, null, null)
,
      new TextBoxModel(this.formGroup.controls['lookupcode_edit'] as DatexFormControl, null, false, false, '', null)
      );
    
    this.cells.name = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.name,
      new TextModel(null, null, null, null, null)
,
      new TextBoxModel(this.formGroup.controls['name_edit'] as DatexFormControl, null, false, false, '', null)
      );
    
    this.cells.description = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.description,
      new TextModel(null, null, null, null, null)
,
      new TextBoxModel(this.formGroup.controls['description_edit'] as DatexFormControl, null, false, false, '', null)
      );
    
    this.cells.owner = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.owner,
      new TextModel(null, null, null, null, null)
,
      new SelectBoxModel(
        this.formGroup.controls['owner_edit'] as DatexFormControl, 
        null, null,
        false,
        false,
        '', null)
      );
    
    this.cells.project = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.project,
      new TextModel(null, null, null, null, null)
,
      new SelectBoxModel(
        this.formGroup.controls['project_edit'] as DatexFormControl, 
        null, null,
        false,
        false,
        '', null)
      );
    
    this.cells.group = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.group,
      new TextModel(null, null, null, null, null)
,
      new SelectBoxModel(
        this.formGroup.controls['group_edit'] as DatexFormControl, 
        null, null,
        false,
        false,
        '', null)
      );
    
    this.cells.status = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.status,
      new TextModel(null, null, null, null, null)
,
      new SelectBoxModel(
        this.formGroup.controls['status_edit'] as DatexFormControl, 
        null, null,
        false,
        false,
        '', null)
      );
    
    this.cells.lot_controlled = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.lot_controlled,
      new TextModel(null, null, null, null, null)
,
      new SelectBoxModel(
        this.formGroup.controls['lot_controlled_edit'] as DatexFormControl, 
        null, null,
        true,
        false,
        '', null)
      );
    
    this.cells.serial_controlled = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.serial_controlled,
      new TextModel(null, null, null, null, null)
,
      new SelectBoxModel(
        this.formGroup.controls['serial_controlled_edit'] as DatexFormControl, 
        null, null,
        true,
        false,
        '', null)
      );
    
    this.cells.fixed_weight = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.fixed_weight,
      new TextModel(null, null, null, null, null)
,
      new SelectBoxModel(
        this.formGroup.controls['fixed_weight_edit'] as DatexFormControl, 
        null, null,
        true,
        false,
        '', null)
      );
    
    this.cells.fixed_dimension = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.fixed_dimension,
      new TextModel(null, null, null, null, null)
,
      new SelectBoxModel(
        this.formGroup.controls['fixed_dimension_edit'] as DatexFormControl, 
        null, null,
        true,
        false,
        '', null)
      );
    
    this.cells.fixed_volume = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.fixed_volume,
      new TextModel(null, null, null, null, null)
,
      new SelectBoxModel(
        this.formGroup.controls['fixed_volume_edit'] as DatexFormControl, 
        null, null,
        true,
        false,
        '', null)
      );
    
    this.cells.allocation_strategy = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.allocation_strategy,
      new TextModel(null, null, null, null, null)
,
      new SelectBoxModel(
        this.formGroup.controls['allocation_strategy_edit'] as DatexFormControl, 
        null, null,
        false,
        false,
        '', null)
      );
    
    this.cells.storage_category_rule = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.storage_category_rule,
      new TextModel(null, null, null, null, null)
,
      new SelectBoxModel(
        this.formGroup.controls['storage_category_rule_edit'] as DatexFormControl, 
        null, null,
        false,
        false,
        '', null)
      );
    
    this.cells.base_uom = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.base_uom,
      new TextModel(null, null, null, null, null)
,
      new SelectBoxModel(
        this.formGroup.controls['base_uom_edit'] as DatexFormControl, 
        null, null,
        true,
        false,
        '', null)
      );
    
    this.cells.base_uom_net_weight = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.base_uom_net_weight,
      new TextModel(null, null,  'number', '0.00', null)
,
      new NumberBoxModel(this.formGroup.controls['base_uom_net_weight_edit'] as DatexFormControl, null, false, false, '0.00', '', null)
      );
    
    this.cells.base_uom_shipping_weight = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.base_uom_shipping_weight,
      new TextModel(null, null,  'number', '0.00', null)
,
      new NumberBoxModel(this.formGroup.controls['base_uom_shipping_weight_edit'] as DatexFormControl, null, false, false, '0.00', '', null)
      );
    
    this.cells.base_uom_upc = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.base_uom_upc,
      new TextModel(null, null, null, null, null)
,
      new TextBoxModel(this.formGroup.controls['base_uom_upc_edit'] as DatexFormControl, null, false, false, '', null)
      );
    
    this.cells.base_uom_pallet_tie = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.base_uom_pallet_tie,
      new TextModel(null, null,  'number', '0', null)
,
      new NumberBoxModel(this.formGroup.controls['base_uom_pallet_tie_edit'] as DatexFormControl, null, false, false, '0', '', null)
      );
    
    this.cells.base_uom_pallet_high = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.base_uom_pallet_high,
      new TextModel(null, null,  'number', '0', null)
,
      new NumberBoxModel(this.formGroup.controls['base_uom_pallet_high_edit'] as DatexFormControl, null, false, false, '0', '', null)
      );
    
    this.cells.base_uom_length = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.base_uom_length,
      new TextModel(null, null,  'number', '0.00', null)
,
      new NumberBoxModel(this.formGroup.controls['base_uom_length_edit'] as DatexFormControl, null, false, false, '0.00', '', null)
      );
    
    this.cells.base_uom_width = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.base_uom_width,
      new TextModel(null, null,  'number', '0.00', null)
,
      new NumberBoxModel(this.formGroup.controls['base_uom_width_edit'] as DatexFormControl, null, false, false, '0.00', '', null)
      );
    
    this.cells.base_uom_height = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.base_uom_height,
      new TextModel(null, null,  'number', '0.00', null)
,
      new NumberBoxModel(this.formGroup.controls['base_uom_height_edit'] as DatexFormControl, null, false, false, '0.00', '', null)
      );
    
    this.cells.base_uom_net_volume = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.base_uom_net_volume,
      new TextModel(null, null,  'number', '0.00', null)
,
      new NumberBoxModel(this.formGroup.controls['base_uom_net_volume_edit'] as DatexFormControl, null, false, false, '0.00', '', null)
      );
    
    this.cells.base_uom_shipping_volume = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.base_uom_shipping_volume,
      new TextModel(null, null,  'number', '0.00', null)
,
      new NumberBoxModel(this.formGroup.controls['base_uom_shipping_volume_edit'] as DatexFormControl, null, false, false, '0.00', '', null)
      );
    
    this.cells.base_uom_weight_unit = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.base_uom_weight_unit,
      new TextModel(null, null, null, null, null)
,
      new SelectBoxModel(
        this.formGroup.controls['base_uom_weight_unit_edit'] as DatexFormControl, 
        null, null,
        false,
        false,
        '', null)
      );
    
    this.cells.base_uom_dimension_unit = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.base_uom_dimension_unit,
      new TextModel(null, null, null, null, null)
,
      new SelectBoxModel(
        this.formGroup.controls['base_uom_dimension_unit_edit'] as DatexFormControl, 
        null, null,
        false,
        false,
        '', null)
      );
    
    this.cells.base_uom_volume_unit = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.base_uom_volume_unit,
      new TextModel(null, null, null, null, null)
,
      new SelectBoxModel(
        this.formGroup.controls['base_uom_volume_unit_edit'] as DatexFormControl, 
        null, null,
        false,
        false,
        '', null)
      );
    
    
  }

  async $initializeExisting(entity: IExcelMaterialImport_excel_material_import_gridComponentEntity) {
    this.entity = entity;

    this.rowId = [this.entity.Id].join('-');

    await this.$dataLoaded();
  }

  async $initializeNew(entity?: IExcelMaterialImport_excel_material_import_gridComponentEntity) {
    this.isNew = true;

    if (entity) {
      this.entity = entity;
    }
    else {
      this.entity = {};
      await this.on_init_new_row();
    }

    this.rowId = [this.entity.Id].join('-');
    await this.$dataLoaded();
    // mark the whole form as dirty, since this is a new row 
    // and even if it is valid, it should have a changed state
    this.formGroup.markAsDirty();
  }

  private $unsubscribe$ = new Subject();
  override destroy(): void {
    this.$unsubscribe$.next(null);
    this.$unsubscribe$.complete();
  }

  $init() {
  }

  async $dataLoad() {
    const $row = this;
    const $grid = this.grid;
    const $utils = this.$utils;
    const $resultKey = this.entity.Id;
    const inParams = {
      $keys:[$resultKey],
      projectId:  $grid.vars.projectId ,
    };
    const data = await this.$datasources.ExcelMaterialImport.ds_material_import_grid.getByKeys(inParams);
    
    await this.grid.$applyLinkedDatasourcesAndCustomColumns(inParams, data);
      
    this.entity = data.result[0] as IExcelMaterialImport_excel_material_import_gridComponentEntity;
    await this.$dataLoaded();
  }

  async $dataLoaded() {
    const $row = this;
    const $grid = this.grid;
    const $utils = this.$utils;
    (this.cells.Id.displayControl as TextModel).text = $row.entity.Id?.toString();
    (this.cells.lookupcode.displayControl as TextModel).text = $row.entity?.LookupCode;
    (this.cells.lookupcode.editControl as TextBoxModel).reset($row.entity?.LookupCode);
    (this.cells.name.displayControl as TextModel).text = $row.entity.Name;
    (this.cells.name.editControl as TextBoxModel).reset($row.entity.Name);
    (this.cells.description.displayControl as TextModel).text = $row.entity.Description;
    (this.cells.description.editControl as TextBoxModel).reset($row.entity.Description);
    (this.cells.owner.displayControl as TextModel).text = $row.entity.Project?.Owner?.LookupCode;
    (this.cells.owner.editControl as SelectBoxModel).reset($row.entity.Project?.OwnerId);
    (this.cells.project.displayControl as TextModel).text = $row.entity.Project?.LookupCode;
    (this.cells.project.editControl as SelectBoxModel).reset($row.entity.ProjectId);
    (this.cells.group.displayControl as TextModel).text = $row.entity.MaterialGroup?.Name;
    (this.cells.group.editControl as SelectBoxModel).reset($row.entity.MaterialGroupId);
    (this.cells.status.displayControl as TextModel).text = $row.entity.Status?.Name;
    (this.cells.status.editControl as SelectBoxModel).reset($row.entity.StatusId);
    (this.cells.lot_controlled.displayControl as TextModel).text = $row.entity.ControllerTypeId == 2 || $row.entity.ControllerTypeId == 4 ? 'Y' : 'N';
    (this.cells.lot_controlled.editControl as SelectBoxModel).reset($row.entity.ControllerTypeId == 2 || $row.entity.ControllerTypeId == 4 ? 'Y' : 'N');
    (this.cells.serial_controlled.displayControl as TextModel).text = $row.entity.ControllerTypeId == 3 || $row.entity.ControllerTypeId == 4 ? 'Y' : 'N';
    (this.cells.serial_controlled.editControl as SelectBoxModel).reset($row.entity.ControllerTypeId == 3 || $row.entity.ControllerTypeId == 4 ? 'Y' : 'N');
    (this.cells.fixed_weight.displayControl as TextModel).text = ($row.entity.IsFixedWeight == false ? 'N' : 'Y');
    (this.cells.fixed_weight.editControl as SelectBoxModel).reset(($row.entity.IsFixedWeight == false ? 'N' : 'Y'));
    (this.cells.fixed_dimension.displayControl as TextModel).text = ($row.entity.IsFixedLength == false ? 'N' : 'Y');
    (this.cells.fixed_dimension.editControl as SelectBoxModel).reset(($row.entity.IsFixedLength == false ? 'N' : 'Y'));
    (this.cells.fixed_volume.displayControl as TextModel).text = ($row.entity.IsFixedVolume == false ? 'N' : 'Y');
    (this.cells.fixed_volume.editControl as SelectBoxModel).reset(($row.entity.IsFixedVolume == false ? 'N' : 'Y'));
    (this.cells.allocation_strategy.displayControl as TextModel).text = $row.entity.AllocationStrategy?.Name;
    (this.cells.allocation_strategy.editControl as SelectBoxModel).reset($row.entity.AllocationStrategyId);
    (this.cells.storage_category_rule.displayControl as TextModel).text = $row.entity.StorageCategoryRule?.Name;
    (this.cells.storage_category_rule.editControl as SelectBoxModel).reset($row.entity.StorageCategoryRuleId);
    (this.cells.base_uom.displayControl as TextModel).text = $row.entity.basePackaging?.Packaging?.ShortName;
    (this.cells.base_uom.editControl as SelectBoxModel).reset($row.entity.basePackaging?.PackagingId);
    (this.cells.base_uom_net_weight.displayControl as TextModel).text = $row.entity.basePackaging?.Weight?.toString();
    (this.cells.base_uom_net_weight.editControl as NumberBoxModel).reset($row.entity.basePackaging?.Weight);
    (this.cells.base_uom_shipping_weight.displayControl as TextModel).text = $row.entity.basePackaging?.ShippingWeight?.toString();
    (this.cells.base_uom_shipping_weight.editControl as NumberBoxModel).reset($row.entity.basePackaging?.ShippingWeight);
    (this.cells.base_uom_upc.displayControl as TextModel).text = $row.entity.basePackaging?.UpcCode;
    (this.cells.base_uom_upc.editControl as TextBoxModel).reset($row.entity.basePackaging?.UpcCode);
    (this.cells.base_uom_pallet_tie.displayControl as TextModel).text = $row.entity.basePackaging?.PalletTie?.toString();
    (this.cells.base_uom_pallet_tie.editControl as NumberBoxModel).reset($row.entity.basePackaging?.PalletTie);
    (this.cells.base_uom_pallet_high.displayControl as TextModel).text = $row.entity.basePackaging?.PalletHigh?.toString();
    (this.cells.base_uom_pallet_high.editControl as NumberBoxModel).reset($row.entity.basePackaging?.PalletHigh);
    (this.cells.base_uom_length.displayControl as TextModel).text = $row.entity.basePackaging?.Length?.toString();
    (this.cells.base_uom_length.editControl as NumberBoxModel).reset($row.entity.basePackaging?.Length);
    (this.cells.base_uom_width.displayControl as TextModel).text = $row.entity.basePackaging?.Width?.toString();
    (this.cells.base_uom_width.editControl as NumberBoxModel).reset($row.entity.basePackaging?.Width);
    (this.cells.base_uom_height.displayControl as TextModel).text = $row.entity.basePackaging?.Height?.toString();
    (this.cells.base_uom_height.editControl as NumberBoxModel).reset($row.entity.basePackaging?.Height);
    (this.cells.base_uom_net_volume.displayControl as TextModel).text = $row.entity.basePackaging?.Volume?.toString();
    (this.cells.base_uom_net_volume.editControl as NumberBoxModel).reset($row.entity.basePackaging?.Volume);
    (this.cells.base_uom_shipping_volume.displayControl as TextModel).text = $row.entity.basePackaging?.ShippingVolume?.toString();
    (this.cells.base_uom_shipping_volume.editControl as NumberBoxModel).reset($row.entity.basePackaging?.ShippingVolume);
    (this.cells.base_uom_weight_unit.displayControl as TextModel).text = $row.entity.basePackaging?.WeightUom.Short_name;
    (this.cells.base_uom_weight_unit.editControl as SelectBoxModel).reset($row.entity.basePackaging?.WeightUomId);
    (this.cells.base_uom_dimension_unit.displayControl as TextModel).text = $row.entity.basePackaging?.DimensionsUom.Short_name;
    (this.cells.base_uom_dimension_unit.editControl as SelectBoxModel).reset($row.entity.basePackaging?.DimensionUomId);
    (this.cells.base_uom_volume_unit.displayControl as TextModel).text = $row.entity.basePackaging?.VolumeUom.Short_name;
    (this.cells.base_uom_volume_unit.editControl as SelectBoxModel).reset($row.entity.basePackaging?.VolumeUomId);

  }

  override async refresh() {
    await this.$dataLoad();
    // grid refresh skipSelf=true, skipParent=false, skipChildren=false  
    this.grid.$refreshEvent.emit();
  }

  override async save() {
    if (this.isNew) {
      await this.on_save_new_row();
      this.isNew = false;
    } else {
      await this.on_save_existing_row();
    } 
  }

  override $cellClicked(cellId: string) {
    super.$cellClicked(cellId);
    switch(cellId) {
    }
  }

  //#region private flows
  on_init_new_row(event = null) {
    return this.on_init_new_rowInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_init_new_rowInternal(
    $row: ExcelMaterialImport_excel_material_import_gridComponentRowModel,
  $grid: ExcelMaterialImport_excel_material_import_gridComponent, 
    $shell: ExcelMaterialImport_ShellService,
    $datasources: ExcelMaterialImport_DatasourceService,
    $flows: ExcelMaterialImport_FlowService,
    $reports: ExcelMaterialImport_ReportService,
    $settings: SettingsValuesService,
    $operations: ExcelMaterialImport_OperationService,
    $utils: UtilsService,
    $context: ExcelMaterialImport_excel_material_import_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: ExcelMaterialImport_LocalizationService,
    $event: any
  ) {
    this.$logger.log('ExcelMaterialImport', 'excel_material_import_grid.on_init_new_row');
  const nextId = (await $flows.Utilities.reserve_nextId_flow({ entity: "Material" })).nextId;
  
  
  $row.entity = {
      Id: nextId
  };
  
  
  
  // Initialize read only cells if a user manually adds a new row.
  $row.cells.base_uom.editControl.readOnly = false;
  $row.cells.project.editControl.readOnly = false;
  $row.cells.fixed_dimension.editControl.readOnly = false;
  $row.cells.fixed_volume.editControl.readOnly = false;
  $row.cells.fixed_weight.editControl.readOnly = false;
  $row.cells.serial_controlled.editControl.readOnly = false;
  $row.cells.lot_controlled.editControl.readOnly = false;
  
  
  
  
  
  
  
  
  
  }
  on_save_existing_row(event = null) {
    return this.on_save_existing_rowInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_save_existing_rowInternal(
    $row: ExcelMaterialImport_excel_material_import_gridComponentRowModel,
  $grid: ExcelMaterialImport_excel_material_import_gridComponent, 
    $shell: ExcelMaterialImport_ShellService,
    $datasources: ExcelMaterialImport_DatasourceService,
    $flows: ExcelMaterialImport_FlowService,
    $reports: ExcelMaterialImport_ReportService,
    $settings: SettingsValuesService,
    $operations: ExcelMaterialImport_OperationService,
    $utils: UtilsService,
    $context: ExcelMaterialImport_excel_material_import_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: ExcelMaterialImport_LocalizationService,
    $event: any
  ) {
    this.$logger.log('ExcelMaterialImport', 'excel_material_import_grid.on_save_existing_row');
  const allRequiredFieldHaveValue = $utils.isAllDefined(
      $row.cells.lookupcode.editControl.value
  );
  
  if (allRequiredFieldHaveValue === false) {
      $shell.ExcelMaterialImport.openErrorDialog('Save', 'Missing Required fields');
      throw new Error('Missing Required fields'); // to prevent displayMode 
  }
  
  const payload: any = {};
  
  if ($row.cells.lookupcode.editControl.isChanged) {
      payload.LookupCode = $row.cells.lookupcode.editControl.value;
  }
  if ($row.cells.name.editControl.isChanged) {
      payload.Name = $row.cells.name.editControl.value;
  }
  if ($row.cells.description.editControl.isChanged) {
      payload.Description = $row.cells.description.editControl.value;
  }
  if ($row.cells.group.editControl.isChanged) {
      payload.MaterialGroupId = $row.cells.group.editControl.value;
  }
  if ($row.cells.status.editControl.isChanged) {
      payload.StatusId = $row.cells.status.editControl.value;
  }
  if ($row.cells.allocation_strategy.editControl.isChanged) {
      payload.AllocationStrategyId = $row.cells.allocation_strategy.editControl.value;
  }
  if ($row.cells.storage_category_rule.editControl.isChanged) {
      payload.StorageCategoryRuleId = $row.cells.storage_category_rule.editControl.value;
  }
  // Update material packaging
  let payloadPackage: any = {};
  
  
  
  if ($row.cells.base_uom_upc.editControl.isChanged) {
      payloadPackage.UpcCode = $row.cells.base_uom_upc.editControl.value;
  }
  if ($row.cells.base_uom_net_weight.editControl.isChanged) {
      payloadPackage.Weight = parseFloat($row.cells.base_uom_net_weight.editControl.value);
  }
  if ($row.cells.base_uom_shipping_weight.editControl.isChanged) {
      payloadPackage.ShippingWeight = parseFloat($row.cells.base_uom_shipping_weight.editControl.value);
  }
  if ($row.cells.base_uom_pallet_tie.editControl.isChanged) {
      payloadPackage.PalletTie = parseInt($row.cells.base_uom_pallet_tie.editControl.value);
  }
  if ($row.cells.base_uom_pallet_high.editControl.isChanged) {
      payloadPackage.PalletHigh = parseInt($row.cells.base_uom_pallet_high.editControl.value);
  }
  if ($row.cells.base_uom_net_volume.editControl.isChanged) {
      payloadPackage.Volume = parseFloat($row.cells.base_uom_net_volume.editControl.value);
  }
  if ($row.cells.base_uom_shipping_volume.editControl.isChanged) {
      payloadPackage.ShippingVolume = parseFloat($row.cells.base_uom_shipping_volume.editControl.value);
  }
  if ($row.cells.base_uom_length.editControl.isChanged) {
      payloadPackage.Length = parseFloat($row.cells.base_uom_length.editControl.value);
  }
  if ($row.cells.base_uom_width.editControl.isChanged) {
      payloadPackage.Width = parseFloat($row.cells.base_uom_width.editControl.value);
  }
  if ($row.cells.base_uom_height.editControl.isChanged) {
      payloadPackage.Height = parseFloat($row.cells.base_uom_height.editControl.value);
  }
  if ($row.cells.base_uom_weight_unit.editControl.isChanged) {
      payloadPackage.WeightUomId = parseFloat($row.cells.base_uom_weight_unit.editControl.value);
  }
  if ($row.cells.base_uom_dimension_unit.editControl.isChanged) {
      payloadPackage.DimensionUomId = parseFloat($row.cells.base_uom_dimension_unit.editControl.value);
  }
  if ($row.cells.base_uom_volume_unit.editControl.isChanged) {
      payloadPackage.VolumeUomId = parseFloat($row.cells.base_uom_volume_unit.editControl.value);
  }
  
  
  
  
  try {
      const materialId = $row.entity.Id;
      await $flows.Utilities.crud_update_flow({ entitySet: 'Materials', id: materialId, entity: payload });
      await $flows.Utilities.crud_update_dual_pk_flow({
          entitySet: 'MaterialsPackagingsLookup',
          pk1String: 'MaterialId',
          pk1: materialId,
          pk2String: 'PackagingId',
          pk2: $row.entity.basePackaging.PackagingId,
          entity: payloadPackage
      });
  
      await $row.refresh();
      // Lock down read only cells
      $row.cells.base_uom.editControl.readOnly = true;
      $row.cells.owner.editControl.readOnly = true;
      $row.cells.project.editControl.readOnly = true;
      $row.cells.fixed_dimension.editControl.readOnly = true;
      $row.cells.fixed_volume.editControl.readOnly = true;
      $row.cells.fixed_weight.editControl.readOnly = true;
      $row.cells.serial_controlled.editControl.readOnly = true;
      $row.cells.lot_controlled.editControl.readOnly = true;
  }
  catch (error) {
      $shell.ExcelMaterialImport.showErrorDetails('Save', 'Error on save.', error);
      throw error; // to prevent displayMode 
  }
  
  }
  on_save_new_row(event = null) {
    return this.on_save_new_rowInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_save_new_rowInternal(
    $row: ExcelMaterialImport_excel_material_import_gridComponentRowModel,
  $grid: ExcelMaterialImport_excel_material_import_gridComponent, 
    $shell: ExcelMaterialImport_ShellService,
    $datasources: ExcelMaterialImport_DatasourceService,
    $flows: ExcelMaterialImport_FlowService,
    $reports: ExcelMaterialImport_ReportService,
    $settings: SettingsValuesService,
    $operations: ExcelMaterialImport_OperationService,
    $utils: UtilsService,
    $context: ExcelMaterialImport_excel_material_import_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: ExcelMaterialImport_LocalizationService,
    $event: any
  ) {
    this.$logger.log('ExcelMaterialImport', 'excel_material_import_grid.on_save_new_row');
  const allRequiredFieldHaveValue = $utils.isAllDefined(
      $row.cells.lookupcode.editControl.value,
      $row.cells.name.editControl.value,
      $row.cells.description.editControl.value,
      $row.cells.owner.editControl.value,
      $row.cells.project.editControl.value
  );
  
  if (allRequiredFieldHaveValue === false) {
      $shell.ExcelMaterialImport.openErrorDialog('Save', 'Missing Required fields');
      throw new Error('Missing Required fields'); // to prevent displayMode 
  } else {
  
      try {
          var errors = ''
          var projectId = $row.entity.ProjectId ? $row.entity.ProjectId : $row.cells.project.editControl.value
          const materials = (await $datasources.ExcelMaterialImport.ds_get_material_by_lookupcode_and_projectId.get(
              {
                  lookupcode: $row.cells.lookupcode.editControl.value,
                  projectId: projectId
              })).result;
          if ($utils.isDefined(materials)) {
  
              errors += 'Duplicate material found';
              $row.cells.error.displayControl.text = errors;
              throw new Error('Duplicate material found')
  
          }
  
          if ($row.cells.fixed_weight.editControl.value === 'Y') {
  
              if (!$utils.isAllDefined($row.cells.base_uom_shipping_weight.editControl.value, $row.cells.base_uom_net_weight.editControl.value)) {
                  errors += 'Fixed Weight True missing Net and or Shipping Weight(s)';
                  $row.cells.error.displayControl.text = errors;
                  throw new Error('Fixed Weight True missing Net and or Shipping Weight(s)')
              }
          }
  
          if ($row.cells.fixed_dimension.editControl.value === 'Y') {
  
              if (!$utils.isAllDefined($row.cells.base_uom_height.editControl.value, $row.cells.base_uom_length.editControl.value, $row.cells.base_uom_width.editControl.value)) {
                  errors += 'Fixed Length True missing Length, Width and or Height';
                  $row.cells.error.displayControl.text = errors;
                  throw new Error('Fixed Length True missing Length, Width and or Height')
              }
          }
  
          if ($row.cells.fixed_volume.editControl.value === 'Y') {
  
              if (!$utils.isAllDefined($row.cells.base_uom_shipping_volume.editControl.value, $row.cells.base_uom_net_volume.editControl.value)) {
                  errors += 'Fixed Volume True missing Net and or Shipping Volume(s)';
                  $row.cells.error.displayControl.text = errors;
                  throw new Error('Fixed Volume True missing Net and or Shipping Volume(s)')
              }
          }
  
  
  
          $row.cells.error.displayControl.text = '';
  
  
          // Create global material
          const nextGlobalId = (await $flows.Utilities.reserve_nextId_flow({ entity: "GlobalMaterial" })).nextId;
    
  
          var ControllerTypeId = null;
          if ($row.cells.lot_controlled.editControl.value === 'N' && $row.cells.serial_controlled.editControl.value === 'N') {
              ControllerTypeId = 1;
          } else if ($row.cells.lot_controlled.editControl.value === 'Y' && $row.cells.serial_controlled.editControl.value === 'N') {
              ControllerTypeId = 2;
          } else if ($row.cells.lot_controlled.editControl.value === 'N' && $row.cells.serial_controlled.editControl.value === 'Y') {
              ControllerTypeId = 3;
          } else if ($row.cells.lot_controlled.editControl.value === 'Y' && $row.cells.serial_controlled.editControl.value === 'Y') {
              ControllerTypeId = 4;
          } else {
              ControllerTypeId = 1;
          }
  
          var fixedWeight = null;
          if ($row.cells.fixed_weight.editControl.value === 'Y') {
              fixedWeight = true;
          } else {
              fixedWeight = false;
          }
  
          var fixedDimension = null;
          if ($row.cells.fixed_dimension.editControl.value === 'Y') {
              fixedDimension = true;
          } else {
              fixedDimension = false;
          }
  
          var fixedVolume = null;
          if ($row.cells.fixed_volume.editControl.value === 'Y') {
              fixedVolume = true;
          } else {
              fixedVolume = false;
          }
  
          //Create material packaging
  
          var Length = null
          var Width = null
          var Height = null
          var netWeight = null
          var netVolume = null
          var shippingWeight = null
          var shippingVolume = null
  
          if ($utils.isDefined($row.cells.base_uom_length.editControl.value)) {
              Length = $row.cells.base_uom_length.editControl.value;
          } else {
              Length = 1
          }
  
          if ($utils.isDefined($row.cells.base_uom_width.editControl.value)) {
              Width = $row.cells.base_uom_width.editControl.value;
          } else {
              Width = 1
          }
  
          if ($utils.isDefined($row.cells.base_uom_height.editControl.value)) {
              Height = $row.cells.base_uom_height.editControl.value;
          } else {
              Height = 1
          }
  
          if ($utils.isDefined($row.cells.base_uom_net_weight.editControl.value)) {
              netWeight = $row.cells.base_uom_net_weight.editControl.value;
          } else {
              netWeight = 1
          }
  
          if ($utils.isDefined($row.cells.base_uom_net_volume.editControl.value)) {
              netVolume = $row.cells.base_uom_net_volume.editControl.value;
          } else {
              netVolume = 1
          }
  
          if ($utils.isDefined($row.cells.base_uom_shipping_weight.editControl.value)) {
              shippingWeight = $row.cells.base_uom_shipping_weight.editControl.value
          } else {
              shippingWeight = 1
          }
  
          if ($utils.isDefined($row.cells.base_uom_shipping_volume.editControl.value)) {
              shippingVolume = $row.cells.base_uom_shipping_volume.editControl.value;
          } else {
              shippingVolume = 1
          }
  
          var upc = null;
          if ($utils.isDefined($row.cells.base_uom_upc.editControl.value)){
              upc = $row.cells.base_uom_upc.editControl.value.toString();
          }
  
          const payloadMaterialPackaging = {
              "Material": {
  
                  "Id": $row.entity.Id,
                  "ControllerTypeId": ControllerTypeId,
                  "MaterialGroupId": $row.cells.group.editControl.value,
                  "GlobalMaterial": {
  
                      "Id": nextGlobalId,
                      "EnterpriseId": 1,
                      "TypeId": 1,
                      "EligibleForSerialControl": false,
                      "Name": $row.cells.lookupcode.editControl.value,
                      "Description": $row.cells.description.editControl.value,
                      "TransferOptionId": 1
  
                  },
                  "Name": $row.cells.name.editControl.value,
                  "Description": $row.cells.description.editControl.value,
                  "LookupCode": $row.cells.lookupcode.editControl.value,
                  "ProjectId": projectId,
                  "AllocationStrategyId": $row.cells.allocation_strategy.editControl.value,
                  "StorageCategoryRuleId": $row.cells.storage_category_rule.editControl.value,
                  "IsFixedWeight": fixedWeight,
                  "StatusId": $row.cells.status.editControl.value,
  
                  "KitTypeId": 0, // Set to None
                  "PackageAllocationStrategyId": 3,
                  "CycleCountToleranceOptionId": 0,
                  "ExpirationNotification": false,
                  "DisableNonPreferredLocationAlertCreation": false,
                  "IsFinishedGood": false,
                  "ManufacturingPackagingReview": false,
                  "IsFixedLength": fixedDimension,
                  "IsFixedVolume": fixedVolume,
                  "AutoPopulateVendorLot": true,
                  "AutoPopulateSystemLot": true,
                  "EligibleForScaleTicket": false,
                  "MobileSkipCountBack": false,
                  "TransloadMaterial": false,
                  "ByPassLocationMixingRestrictions": false,
                  "ScanSerialOfAllPackageLevels": false,
                  "DoNotScanSerialsOnRecounts": false,
                  "UseLicensePlateFifoAllocation": false,
                  "ReceiveAsInactive": false,
                  "SkipCycleCount": false,
                  "IsWip": false,
                  "ManufacturingOrdersUseWorstExpirationDate": false,
                  "AllowReceiving": true,
                  "AllowBlindReceiving": true,
                  "AllowShipping": true,
                  "AllowReturns": true,
                  "StandardPrice": 0,
                  "StandardCost": 0,
                  "CurrencyId": 1,
                  "ValuationMethod": ''
  
              },
              "PackagingId": $row.cells.base_uom.editControl.value,
              "IsBasePackaging": true,
              "SubPackagingQuantity": 0,
              "BasePackagingId": $row.cells.base_uom.editControl.value,
              "BasePackagingQuantity": 1,
  
              "AllowFractions": true,
              "AllowInSalesOrder": true,
              "AllowInPurchaseOrder": true,
              "IsReportingDefault": true,
              "IsOrderDefault": false,
              "IsLabelCompliant": false,
              "UseAsShippingContainer": false,
              "DeprecatedPackaging": false,
              "AllowInMobileSales": false,
  
              "ShippingWeight": shippingWeight,
              "Weight": netWeight,
              "TareWeight": 0,
              "WeightUomId": $row.cells.base_uom_weight_unit.editControl.value,
  
              "Height": Height,
              "Width": Width,
              "Length": Length,
              "DimensionUomId": $row.cells.base_uom_dimension_unit.editControl.value,
  
              "Volume": netVolume,
              "ShippingVolume": shippingVolume,
              "VolumeUomId": $row.cells.base_uom_volume_unit.editControl.value,
  
              "PalletTie": $row.cells.base_uom_pallet_tie.editControl.value,
              "PalletHigh": $row.cells.base_uom_pallet_high.editControl.value,
  
              "UpcCode": upc
  
          };
  
          await $flows.Utilities.crud_create_flow({ entitySet: 'MaterialsPackagingsLookup', entity: payloadMaterialPackaging });
  
        
          $row.refresh();
  
          // Lock down read only cells upon creation
          $row.cells.base_uom.editControl.readOnly = true;
          $row.cells.owner.editControl.readOnly = true;
          $row.cells.project.editControl.readOnly = true;
          $row.cells.fixed_dimension.editControl.readOnly = true;
          $row.cells.fixed_volume.editControl.readOnly = true;
          $row.cells.fixed_weight.editControl.readOnly = true;
          $row.cells.serial_controlled.editControl.readOnly = true;
          $row.cells.lot_controlled.editControl.readOnly = true;
  
      }
      catch (error) {
          $shell.ExcelMaterialImport.showErrorDetails('Save', 'Error on save.', error);
          throw error; // to prevent displayMode 
      }
  
  }
  
  
  
  
  
  
  }
  //#endregion private flows

}


@Component({
  standalone: true,
  imports: [
    SharedModule,
    forwardRef(() => ExcelMaterialImport_owners_dd_singleComponent),
    forwardRef(() => ExcelMaterialImport_projects_dd_singleComponent),
    forwardRef(() => ExcelMaterialImport_material_groups_dd_singleComponent),
    forwardRef(() => ExcelMaterialImport_material_statuses_dd_singleComponent),
    forwardRef(() => ExcelMaterialImport_yn_dd_singleComponent),
    forwardRef(() => ExcelMaterialImport_allocation_strategy_dd_singleComponent),
    forwardRef(() => ExcelMaterialImport_storage_category_rules_dd_singleComponent),
    forwardRef(() => ExcelMaterialImport_material_packagings_dd_singleComponent),
    forwardRef(() => ExcelMaterialImport_measurement_units_dd_singleComponent),
  ],
  selector: 'ExcelMaterialImport-excel_material_import_grid',
  templateUrl: './ExcelMaterialImport.excel_material_import_grid.component.html'
})
export class ExcelMaterialImport_excel_material_import_gridComponent extends BaseComponent implements OnInit, OnDestroy {
  //#region Outputs
  @Output()
  $finish = new EventEmitter();
  @Output()
  $refreshEvent = new EventEmitter();
  //#endregion Outputs

  entities: IExcelMaterialImport_excel_material_import_gridComponentEntity[];

  pageSize = 10;
  pageSkip = 0;
  totalCount = 0;
  loadingStatus = ELoadingStatus.Loading;

canEdit: boolean = true;
// to stop add from flow
// canAdd = false; //hide add button, check on exitFromLastCell 
// bottomToolbar.addLine.hidden = true; //hide add button, no check on exitFromLastCell 
// bottomToolbar.addLine.control.readOnly = true; //disable add button, check on exitFromLastCell 
canAdd: boolean = true; 
  
  containerStyles: GridContainerStyle = new GridContainerStyle('cellsWidth', ['fit-content-table']);




  //#region Variables
  vars: { projectId?: number } = { };
  //#endregion
  //#region Events
  
  //#endregion

  headers = {
     Id: new GridHeaderModel(new HeaderStyles(null, null), 'Id', 'ID', false, false, null, false),       error: new GridHeaderModel(new HeaderStyles(null, null), 'error', 'Errors', false, false, null, false),       lookupcode: new GridHeaderModel(new HeaderStyles(null, null), 'lookupcode', 'Material code', true, false, null, false),       name: new GridHeaderModel(new HeaderStyles(null, null), 'name', 'Name', true, false, null, false),       description: new GridHeaderModel(new HeaderStyles(null, null), 'description', 'Description', true, false, null, false),       owner: new GridHeaderModel(new HeaderStyles(null, null), 'owner', 'Owner', true, false, null, false),       project: new GridHeaderModel(new HeaderStyles(null, null), 'project', 'Project', true, false, null, false),       group: new GridHeaderModel(new HeaderStyles(null, null), 'group', 'Group', true, false, null, false),       status: new GridHeaderModel(new HeaderStyles(null, null), 'status', 'Status', true, false, null, false),       lot_controlled: new GridHeaderModel(new HeaderStyles(null, null), 'lot_controlled', 'Lot controlled', true, false, null, false),       serial_controlled: new GridHeaderModel(new HeaderStyles(null, null), 'serial_controlled', 'Serial controlled', true, false, null, false),       fixed_weight: new GridHeaderModel(new HeaderStyles(null, null), 'fixed_weight', 'Fixed weight', true, false, null, false),       fixed_dimension: new GridHeaderModel(new HeaderStyles(null, null), 'fixed_dimension', 'Fixed dimension', true, false, null, false),       fixed_volume: new GridHeaderModel(new HeaderStyles(null, null), 'fixed_volume', 'Fixed volume', true, false, null, false),       allocation_strategy: new GridHeaderModel(new HeaderStyles(null, null), 'allocation_strategy', 'Allocation strategy', true, false, null, false),       storage_category_rule: new GridHeaderModel(new HeaderStyles(null, null), 'storage_category_rule', 'Storage category rule', false, false, null, false),       base_uom: new GridHeaderModel(new HeaderStyles(null, null), 'base_uom', 'Base UOM', true, false, null, false),       base_uom_net_weight: new GridHeaderModel(new HeaderStyles(null, null), 'base_uom_net_weight', 'Base UOM net weight', false, false, null, false),       base_uom_shipping_weight: new GridHeaderModel(new HeaderStyles(null, null), 'base_uom_shipping_weight', 'Base UOM shipping weight', false, false, null, false),       base_uom_upc: new GridHeaderModel(new HeaderStyles(null, null), 'base_uom_upc', 'Base UOM UPC', false, false, null, false),       base_uom_pallet_tie: new GridHeaderModel(new HeaderStyles(null, null), 'base_uom_pallet_tie', 'Base UOM pallet tie', false, false, null, false),       base_uom_pallet_high: new GridHeaderModel(new HeaderStyles(null, null), 'base_uom_pallet_high', 'Base UOM pallet high', false, false, null, false),       base_uom_length: new GridHeaderModel(new HeaderStyles(null, null), 'base_uom_length', 'Base UOM length', false, false, null, false),       base_uom_width: new GridHeaderModel(new HeaderStyles(null, null), 'base_uom_width', 'Base UOM width', false, false, null, false),       base_uom_height: new GridHeaderModel(new HeaderStyles(null, null), 'base_uom_height', 'Base UOM height', false, false, null, false),       base_uom_net_volume: new GridHeaderModel(new HeaderStyles(null, null), 'base_uom_net_volume', 'Base UOM net volume', false, false, null, false),       base_uom_shipping_volume: new GridHeaderModel(new HeaderStyles(null, null), 'base_uom_shipping_volume', 'Base UOM shipping volume', false, false, null, false),       base_uom_weight_unit: new GridHeaderModel(new HeaderStyles(null, null), 'base_uom_weight_unit', 'Base UOM weight unit', true, false, null, false),       base_uom_dimension_unit: new GridHeaderModel(new HeaderStyles(null, null), 'base_uom_dimension_unit', 'Base UOM dimension unit', true, false, null, false),       base_uom_volume_unit: new GridHeaderModel(new HeaderStyles(null, null), 'base_uom_volume_unit', 'Base UOM volume unit', true, false, null, false),  
  };

  //#region title
  // Make it async so that it won't cause expressionChangedAfterItHasBeenCheckedError
  // The title is often meant to be shown from the parent (shell breadcrumb for example)
  // and often it will cause an expressionChangedAfterItHasBeenCheckedError because 
  // the parent has already been checked and the child now change something on the parent 
  // in dev, CD is run twice
  $titleChange = new EventEmitter<string>(true);
  private $_title: string;
  get title(): string {
    return this.$_title;
  }
  set title(t: string) {
    this.$_title = t;
    this.$titleChange.emit(this.$_title);
  }
  //#endregion title
  rows: ExcelMaterialImport_excel_material_import_gridComponentRowModel[] = [];


  topToolbar = {
      linecount: new ToolModel(new ButtonModel('linecount', new ButtonStyles(null, null), false, false, false, 'Line count', '', null)
    , false)
  };

  bottomToolbar = {
    addLine : new ToolModel(new ButtonModel(null, null, false, false, false, 'Add row', 'icon-ic_fluent_add_circle_20_regular')),
  };




  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    private $shell: ExcelMaterialImport_ShellService,
    private $datasources: ExcelMaterialImport_DatasourceService,
    private $flows: ExcelMaterialImport_FlowService,
    private $reports: ExcelMaterialImport_ReportService,
    private $localization: ExcelMaterialImport_LocalizationService,
    private $operations: ExcelMaterialImport_OperationService,
    private $logger: CleanupLoggerService,
    private $context: ExcelMaterialImport_excel_material_import_grid_ComponentContextService,
    ) {
    super();
    this.title = 'Material import';
    this.$subscribeFormControlValueChanges();
  }

  ngOnInit(): void {
    this.$init();
  }
  


  initialized = false;

  private $unsubscribe$ = new Subject();
  ngOnDestroy(): void {
    this.$unsubscribe$.next(null);
    this.$unsubscribe$.complete();

    this.clearRows();
  }

  async $init() {
    const $grid = this;
    const $utils = this.$utils;

    this.pageSize = 100;


    await this.on_init();
    this.initialized = true;

    this.pageSkip = 0;
    this.refresh(true, true, null);
  }

  protected override $initEmpty() {
    this.clearRows();
  }

  private $subscribeFormControlValueChanges() {

  }

  reload() {
    this.pageSkip = 0;
    this.refresh();
  }

  refresh(
    skipParent = false,
    skipChildren = false,
    childToSkip: string = null) {
    // up
    if (skipParent === false) {
      this.$refreshEvent.emit();
    }

    // self
    const result = this.$dataLoad();

    // children
    if (skipChildren === false) {
    }

    return result;
  }

  async $dataLoad() {
    this.loadingStatus = ELoadingStatus.Loading;
    const $grid = this;
    const $utils = this.$utils;
    const inParams = {
      $top: this.pageSize,
      $skip: this.pageSkip,
      projectId:  $grid.vars.projectId ,
    };
    try {
      const data = await this.$datasources.ExcelMaterialImport.ds_material_import_grid.getList(inParams);
      
      await this.$applyLinkedDatasourcesAndCustomColumns(inParams, data);

      this.entities = data.result as IExcelMaterialImport_excel_material_import_gridComponentEntity[];
      this.totalCount = data.totalCount;

      await this.$dataLoaded();
      if (this.totalCount === 0) {
        this.loadingStatus = ELoadingStatus.NoResults;
      } else {
        this.loadingStatus = ELoadingStatus.Loaded;
      }
    } catch(error) {
      console.error("Error loading data:", error);
      this.loadingStatus = ELoadingStatus.Error;
    }
  }

  async $dataLoaded() {
    const $grid = this;
    const $utils = this.$utils;
    
    this.clearRows();

    if(this.entities) {
      let rowLoadPromises = [];
      for (let entity of this.entities) {
        const row = new ExcelMaterialImport_excel_material_import_gridComponentRowModel(
          this,
          this.$utils,
          this.$settings,
          this.$shell, 
          this.$datasources,
          this.$flows,
          this.$reports,
          this.$localization,
          this.$operations,
          this.$logger,
          this.$context);
        rowLoadPromises.push(row.$initializeExisting(entity));
        this.rows.push(row);
      }
      await Promise.all(rowLoadPromises);
    }

  }

  
    async $applyLinkedDatasourcesAndCustomColumns(inParams: any, outParams: any) {
      const $datasource = { inParams: inParams };
      const $utils = this.$utils;
  
    }

  clearRows() {
    if(this.rows && this.rows.length) {
      this.rows.forEach(r => r.destroy());
    }
    this.rows = [];
  }


  async addRow(entity?: IExcelMaterialImport_excel_material_import_gridComponentEntity) {
    const row = new ExcelMaterialImport_excel_material_import_gridComponentRowModel(
      this,
      this.$utils,
      this.$settings,
      this.$shell, 
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$localization,
      this.$operations,
      this.$logger,
      this.$context);
    await row.$initializeNew(entity);
    this.rows.push(row);
    row.setEditMode();
    return row;
  }
  
  openImageViewer(imageSource: string) {
    this.$shell.openImageViewerDialog(imageSource);
  }

  //#region private flows
  on_excel_export(event = null) {
    return this.on_excel_exportInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_excel_exportInternal(
    $grid: ExcelMaterialImport_excel_material_import_gridComponent,
  
    $shell: ExcelMaterialImport_ShellService,
    $datasources: ExcelMaterialImport_DatasourceService,
    $flows: ExcelMaterialImport_FlowService,
    $reports: ExcelMaterialImport_ReportService,
    $settings: SettingsValuesService,
    $operations: ExcelMaterialImport_OperationService,
    $utils: UtilsService,
    $context: ExcelMaterialImport_excel_material_import_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: ExcelMaterialImport_LocalizationService,
    $event: any
  ) {
    this.$logger.log('ExcelMaterialImport', 'excel_material_import_grid.on_excel_export');
  const wb = $event;
  
  const orderLines = [];
  
  orderLines.push({
      LookupCode: 'Required',
      OwnerLookupCode: 'Required',
      ProjectLookupCode: 'Required',
      Name: 'Required',
      Description: 'Required',
      Group: 'No Group',
      Status: 'Active, Damaged, Discontinued, Inactive',
      LotControlled_YN: 'N',
      SerialControlled_YN: 'N',
      FixedWeight_YN: 'Y',
      FixedDimension_YN: 'Y',
      FixedVolume_YN: 'Y',
      AllocationStrategy: 'FIFO, FEFO, FMFO, LEFO',
      StorageCategoryRule: '',
      BaseUom: 'EA, CS',
      BaseUomNetWeight: '',
      BaseUomShippingWeight: '',
      BaseUomUpc: '',
      BaseUomPalletTie: '',
      BaseUomPalletHigh: '',
      BaseUomLength: '',
      BaseUomWidth: '',
      BaseUomHeight: '',
      BaseUomNetVolume: '',
      BaseUomShippingVolume: '',
      BaseUomWeightUnit: 'g, kg, lb, mt, oz, T, t oz',
      BaseUomDimensionUnit: 'cm, ft, in, m',
      BaseUomVolumeUnit: 'cu. cm., cu. ft., cu. in., cu. m., Gal, L, ml'
  
  });
  
  
  
  const ws = $utils.excel.json_to_sheet(orderLines);
  
  $utils.excel.book_append_sheet(wb, ws, 'MaterialImport');
  
  }
  on_excel_import(event = null) {
    return this.on_excel_importInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_excel_importInternal(
    $grid: ExcelMaterialImport_excel_material_import_gridComponent,
  
    $shell: ExcelMaterialImport_ShellService,
    $datasources: ExcelMaterialImport_DatasourceService,
    $flows: ExcelMaterialImport_FlowService,
    $reports: ExcelMaterialImport_ReportService,
    $settings: SettingsValuesService,
    $operations: ExcelMaterialImport_OperationService,
    $utils: UtilsService,
    $context: ExcelMaterialImport_excel_material_import_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: ExcelMaterialImport_LocalizationService,
    $event: any
  ) {
    this.$logger.log('ExcelMaterialImport', 'excel_material_import_grid.on_excel_import');
  
  
  const wb = $event;
  const wsname = wb.SheetNames[0];
  const ws = wb.Sheets[wsname];
  
  const _batchSize = 500;
  
  $grid.topToolbar.linecount.hidden = false;
  $grid.topToolbar.linecount.control.icon = "icon datex-default-spinner";
  $grid.topToolbar.linecount.control.label = 'Extracting Data..';
  
  const Materials = $utils.excel.sheet_to_json<{
      LookupCode: string,
      OwnerLookupCode: string,
      ProjectLookupCode: string,
      Name: string,
      Description: string,
      Group: string,
      Status: string,
      LotControlled_YN: string,
      SerialControlled_YN: string,
      FixedWeight_YN: string,
      FixedDimension_YN: string,
      FixedVolume_YN: string,
      AllocationStrategy: string,
      StorageCategoryRule: string,
      BaseUom: string,
      BaseUomNetWeight: string,
      BaseUomShippingWeight: string,
      BaseUomUpc: string,
      BaseUomPalletTie: string,
      BaseUomPalletHigh: string,
      BaseUomLength: string,
      BaseUomWidth: string,
      BaseUomHeight: string,
      BaseUomNetVolume: string,
      BaseUomShippingVolume: string,
      BaseUomWeightUnit: string,
      BaseUomDimensionUnit: string,
      BaseUomVolumeUnit: string
  
  }>(ws);
  
  $grid.topToolbar.linecount.control.label = 'Preparing Data...';
  
  // Initialize grid and data
  const candidates = [];
  var linecount = 0;
  var confirmLineCount = 0;
  var totalLineCount = Materials.length;
  
  // Get Bulk Data
  var owners = (await getOwnersPool());
  var materials = (await getMaterialsPool())
  var statuses = (await getMaterialStatusesPool())
  var groups = (await getMaterialGroupsPool())
  var allocations = (await getAllocationStrategiesPool())
  var storageCategories = (await getStorageCategoriesPool())
  var packagings = (await getMaterialPackagingsPool())
  var measurementUnit = (await getMeasurementUnitsPool())
  
  for (const Material of Materials) {
  
      linecount = linecount + 1;
      $grid.topToolbar.linecount.control.label = 'Validating Line ' + linecount.toString() + ' of ' + totalLineCount.toString();
  
      var errors = '';
      if ($utils.isDefined(Material.LookupCode)) {
          var materialLookup = Material.LookupCode.toString();
      }
      if ($utils.isDefined(Material.Name)) {
          var materialName = Material.Name.toString();
      }
      if ($utils.isDefined(Material.Description)) {
          var materialDescription = Material.Description.toString();
      }
  
      const nextId = (await $flows.Utilities.reserve_nextId_flow({ entity: "Material" })).nextId;
      const row = await $grid.addRow({
          Id: nextId
      });
  
      // Get Owner
      let ownerId: number;
      let projectId: number;
  
      if ($utils.isDefined(Material.OwnerLookupCode)) {
          const ownerFound = owners.find(
              o => o.LookupCode.trim().toUpperCase() === Material.OwnerLookupCode.toString().trim().toUpperCase()
          );
          if ($utils.isDefined(ownerFound)) {
              let owner = ownerFound;
              ownerId = owner.Id;
  
              row.cells.owner.editControl.value = ownerId;
  
              // Get Project from Owner
              if ($utils.isDefined(Material.ProjectLookupCode)) {
                  const projectFound = owner.Projects.find(
                      p => p.LookupCode.trim().toUpperCase() === Material.ProjectLookupCode.toString().trim().toUpperCase()
                  );
  
                  if ($utils.isDefined(projectFound)) {
                      projectId = projectFound.Id;
                      row.cells.project.editControl.value = projectId;
                  }
                  else {
                      row.cells.project.editControl.value = null;
                      errors += 'Project does not exist' + ' : ';
                      row.cells.project.editControl.readOnly = false;
                  }
              } else {
                  errors += 'Project not provided' + ' : '
                  row.cells.project.editControl.readOnly = false;
              }
  
          }
          else {
              row.cells.owner.editControl.value = null;
              errors += 'Owner does not exist' + ' : ';
              row.cells.owner.editControl.readOnly = false;
          }
      } else {
          errors += 'Owner not provided' + ' : '
          row.cells.owner.editControl.readOnly = false;
          row.cells.project.editControl.readOnly = false;
      }
  
      var statusId = null;
      if ($utils.isDefined(Material.Status)) {
          const statusFound = statuses.find(
              s => s.Name === Material.Status.toString()
          );
          if ($utils.isDefined(statusFound)) {
              statusId = statusFound.Id;
              row.cells.status.editControl.value = statusId;
          }
          else {
              errors += 'Status does not exist' + ' : '
          }
      } else {
          errors += 'Status not provided' + ' : '
      }
  
      var groupId = null;
      if ($utils.isDefined(Material.Group)) {
          const groupFound = groups.find(
              g => g.Name === Material.Group.toString()
          );
          if ($utils.isDefined(groupFound)) {
              groupId = groupFound.Id;
              row.cells.group.editControl.value = groupId;
          }
          else {
              errors += 'Group does not exist' + ' : '
          }
      } else {
          errors += 'Group not provided' + ' : '
      }
  
  
      if (Material.LotControlled_YN === 'Y') {
          row.cells.lot_controlled.editControl.value = 'Y';
      } else {
          row.cells.lot_controlled.editControl.value = 'N';
      }
      if (Material.SerialControlled_YN === 'Y') {
          row.cells.serial_controlled.editControl.value = 'Y';
      } else {
          row.cells.serial_controlled.editControl.value = 'N';
      }
      if (Material.FixedWeight_YN === 'N') {
          row.cells.fixed_weight.editControl.value = 'N';
      } else {
          row.cells.fixed_weight.editControl.value = 'Y';
      }
      if (Material.FixedDimension_YN === 'N') {
          row.cells.fixed_dimension.editControl.value = 'N';
      } else {
          row.cells.fixed_dimension.editControl.value = 'Y';
      }
      if (Material.FixedVolume_YN === 'N') {
          row.cells.fixed_volume.editControl.value = 'N';
      } else {
          row.cells.fixed_volume.editControl.value = 'Y';
      }
  
      var strategyId = null;
      if ($utils.isDefined(Material.AllocationStrategy)) {
          const strategyFound = allocations.find(
              a => a.Name === Material.AllocationStrategy.toString()
          );
          if ($utils.isDefined(strategyFound)) {
              strategyId = strategyFound.Id;
              row.cells.allocation_strategy.editControl.value = strategyId;
          }
          else {
              errors += 'Allocation strategy does not exist' + ' : '
          }
      } else {
          errors += 'Allocation strategy not provided' + ' : '
      }
  
      var categoryId = null;
      if ($utils.isDefined(Material.StorageCategoryRule)) {
          const categoryFound = storageCategories.find(
              a => a.Name === Material.StorageCategoryRule.toString()
          );
          if ($utils.isDefined(categoryFound)) {
              categoryId = categoryFound.Id;
              row.cells.storage_category_rule.editControl.value = categoryId;
          }
          else {
              errors += 'Storage category rule does not exist' + ' : '
          }
      } 
  
  
  
      var packagingId = null;
      if ($utils.isDefined(Material.BaseUom)) {
          const packagingFound = packagings.find(
              p => p.ShortName === Material.BaseUom.toString()
          );
          if ($utils.isDefined(packagingFound)) {
              packagingId = packagingFound.Id;
              row.cells.base_uom.editControl.value = packagingId;
          }
          else {
              row.cells.base_uom.editControl.value = null;
              errors += 'Incorrect Base Uom provided' + ' : ';
              row.cells.base_uom.editControl.readOnly = false;
          }
      } else {
          errors += 'Base Uom not provided' + ' : ';
          row.cells.base_uom.editControl.readOnly = false;
      }
  
  
  
      row.cells.base_uom_net_weight.editControl.value = Material.BaseUomNetWeight;
      row.cells.base_uom_shipping_weight.editControl.value = Material.BaseUomShippingWeight;
      row.cells.base_uom_upc.editControl.value = Material.BaseUomUpc;
  
      row.cells.base_uom_length.editControl.value = Material.BaseUomLength;
      row.cells.base_uom_width.editControl.value = Material.BaseUomWidth;
      row.cells.base_uom_height.editControl.value = Material.BaseUomHeight;
      row.cells.base_uom_net_volume.editControl.value = Material.BaseUomNetVolume;
      row.cells.base_uom_shipping_volume.editControl.value = Material.BaseUomShippingVolume;
  
  
  
      var volumeUomId = null;
      if ($utils.isDefined(Material.BaseUomVolumeUnit)) {
          const measurementUnitFound = measurementUnit.find(
              v => v.Short_name === Material.BaseUomVolumeUnit.toString() && v.TypeId === 2
          );
          if ($utils.isDefined(measurementUnitFound)) {
              volumeUomId = measurementUnitFound.Id;
              row.cells.base_uom_volume_unit.editControl.value = volumeUomId;
          }
          else {
              row.cells.base_uom_volume_unit.editControl.value = null;
              errors += 'Incorrect Volume Unit Provided' + ' : ';
          }
      } else {
          errors += 'Volume unit not provided' + ' : ';
      }
  
      var weightUomId = null;
      if ($utils.isDefined(Material.BaseUomWeightUnit)) {
          const measurementUnitFound = measurementUnit.find(
              v => v.Short_name === Material.BaseUomWeightUnit.toString() && v.TypeId === 3
          );
          if ($utils.isDefined(measurementUnitFound)) {
              weightUomId = measurementUnitFound.Id;
              row.cells.base_uom_weight_unit.editControl.value = weightUomId;
          }
          else {
              row.cells.base_uom_weight_unit.editControl.value = null;
              errors += 'Incorrect Weight Unit Provided' + ' : ';
          }
      } else {
          errors += 'Weight unit not provided' + ' : ';
      }
  
      var dimensionUomId = null;
      if ($utils.isDefined(Material.BaseUomDimensionUnit)) {
          const measurementUnitFound = measurementUnit.find(
              v => v.Short_name === Material.BaseUomDimensionUnit.toString() && v.TypeId === 1
          );
          if ($utils.isDefined(measurementUnitFound)) {
              dimensionUomId = measurementUnitFound.Id;
              row.cells.base_uom_dimension_unit.editControl.value = dimensionUomId;
          }
          else {
              row.cells.base_uom_dimension_unit.editControl.value = null;
              errors += 'Incorrect Dimension Unit Provided' + ' : ';
          }
      } else {
          errors += 'Dimension unit not provided' + ' : ';
      }
  
  
      if ($utils.isDefined(materialLookup)) {
          row.cells.lookupcode.editControl.value = materialLookup;
      } else {
          errors += 'LookupCode not provided ' + ' : ';
  
      }
  
      if ($utils.isDefined(projectId)) {
          const materialCheck = (await $datasources.ExcelMaterialImport.ds_get_material_by_lookupcode_and_projectId.get({
              lookupcode: materialLookup,
              projectId: projectId
          })).result
  
          if ($utils.isDefined(materialCheck)) {
              errors += 'Material lookup already exists'
          }
      }
  
      if ($utils.isDefined(materialName)) {
          row.cells.name.editControl.value = materialName;
      } else {
          errors += 'Name not provided ' + ' : ';
  
      }
  
      if ($utils.isDefined(materialDescription)) {
          row.cells.description.editControl.value = materialDescription;
      } else {
          errors += 'Description not provided ' + ' : ';
  
      }
  
      if ($utils.isAllDefined(row.entity.ProjectId, materialLookup)) {
          const materialFound = materials.find(
              v => v.LookupCode === materialLookup && v.ProjectId === row.entity.ProjectId
          );
          if ($utils.isDefined(materialFound)) {
              errors += 'Duplicate material found ' + ' : ';
          }
  
      }
  
  
      if ($utils.isDefined(Material.FixedWeight_YN)) {
          if (Material.FixedWeight_YN === 'Y') {
              if (!$utils.isAllDefined(Material.BaseUomShippingWeight, Material.BaseUomNetWeight)) {
                  errors += 'Fixed Weight True missing Net and or Shipping Weight(s)' + ' : ';
                  row.cells.fixed_weight.editControl.readOnly = false;
                  row.cells.serial_controlled.editControl.readOnly = false;
  
              }
          }
      }
  
      if ($utils.isDefined(Material.FixedDimension_YN)) {
          if (Material.FixedDimension_YN === 'Y') {
              if (!$utils.isAllDefined(Material.BaseUomLength, Material.BaseUomWidth, Material.BaseUomHeight)) {
                  errors += 'Fixed Length True missing Length, Width and or Height' + ' : ';
                  row.cells.fixed_dimension.editControl.readOnly = false;
              }
          }
      }
  
      if ($utils.isDefined(Material.FixedVolume_YN)) {
          if (Material.FixedVolume_YN === 'Y') {
              if (!$utils.isAllDefined(Material.BaseUomShippingVolume, Material.BaseUomNetVolume)) {
                  errors += 'Fixed Volume True missing Net and or Shipping Volume(s)' + ' : ';
                  row.cells.fixed_volume.editControl.readOnly = false;
              }
          }
      }
  
      if ($utils.isDefined(Material.BaseUomPalletTie)) {
  
          if (parseInt(Material.BaseUomPalletTie.toString(), 10) > 0) {
              row.cells.base_uom_pallet_tie.editControl.value = Material.BaseUomPalletTie;
          }
          else {
              errors += 'Pallet tie not a number' + ' : '
          }
      }
  
      if ($utils.isDefined(Material.BaseUomPalletHigh)) {
  
          if (parseInt(Material.BaseUomPalletHigh.toString(), 10) > 0) {
              row.cells.base_uom_pallet_high.editControl.value = Material.BaseUomPalletHigh;
          }
          else {
              errors += 'Pallet high not a number' + ' : '
          }
      }
  
  
  
      row.cells.error.displayControl.text = errors;
      candidates.push({ row: row, errors: errors });
  }
  
  
  var totalConfirmLineCount = candidates.length;
  
  for (const candidate of candidates) {
      const noErrors = candidate.errors === '';
      if (noErrors) {
  
          //Check for duplicates within the same file
  
          const materialCheck = (await $datasources.ExcelMaterialImport.ds_get_material_by_lookupcode_and_projectId.get({
              lookupcode: candidate.row.cells.lookupcode.editControl.value,
              projectId: candidate.row.cells.project.editControl.value
          })).result
  
  
          if ($utils.isDefined(materialCheck)) {
              candidate.row.cells.error.displayControl.text = 'Duplicate Material';
          }
          else {
  
              try {
                  confirmLineCount = confirmLineCount + 1;
                  $grid.topToolbar.linecount.control.label = 'Creating Material ' + confirmLineCount.toString() + ' of ' + totalConfirmLineCount.toString();
  
                  // Create global material
                  const nextGlobalId = (await $flows.Utilities.reserve_nextId_flow({ entity: "GlobalMaterial" })).nextId;
  
  
                  var ControllerTypeId = null;
  
                  if (candidate.row.cells.lot_controlled.editControl.value === 'N' && candidate.row.cells.serial_controlled.editControl.value === 'N') {
                      ControllerTypeId = 1;
                  } else if (candidate.row.cells.lot_controlled.editControl.value === 'Y' && candidate.row.cells.serial_controlled.editControl.value === 'N') {
                      ControllerTypeId = 2;
                  } else if (candidate.row.cells.lot_controlled.editControl.value === 'N' && candidate.row.cells.serial_controlled.editControl.value === 'Y') {
                      ControllerTypeId = 3;
                  } else if (candidate.row.cells.lot_controlled.editControl.value === 'Y' && candidate.row.cells.serial_controlled.editControl.value === 'Y') {
                      ControllerTypeId = 4;
                  } else {
                      ControllerTypeId = 1;
                  }
  
                  var fixedWeight = null;
                  if (candidate.row.cells.fixed_weight.editControl.value === 'Y') {
                      fixedWeight = true;
                  } else {
                      fixedWeight = false;
                  }
  
                  var fixedDimension = null;
                  if (candidate.row.cells.fixed_dimension.editControl.value === 'Y') {
                      fixedDimension = true;
                  } else {
                      fixedDimension = false;
                  }
  
                  var fixedVolume = null;
                  if (candidate.row.cells.fixed_volume.editControl.value === 'Y') {
                      fixedVolume = true;
                  } else {
                      fixedVolume = false;
                  }
  
                  //Create material packaging
  
                  var Length = null
                  var Width = null
                  var Height = null
                  var netWeight = null
                  var netVolume = null
                  var shippingWeight = null
                  var shippingVolume = null
                  var PalletHigh = null
                  var PalletTie = null
  
                  if ($utils.isDefined(candidate.row.cells.base_uom_length.editControl.value) && !isNaN(candidate.row.cells.base_uom_length.editControl.value)) {
                      Length = Number(candidate.row.cells.base_uom_length.editControl.value);
                  } else {
                      Length = 1
                  }
  
                  if ($utils.isDefined(candidate.row.cells.base_uom_width.editControl.value) && !isNaN(candidate.row.cells.base_uom_width.editControl.value)) {
                      Width = Number(candidate.row.cells.base_uom_width.editControl.value);
                  } else {
                      Width = 1
                  }
  
                  if ($utils.isDefined(candidate.row.cells.base_uom_height.editControl.value) && !isNaN(candidate.row.cells.base_uom_height.editControl.value)) {
                      Height = Number(candidate.row.cells.base_uom_height.editControl.value);
                  } else {
                      Height = 1
                  }
  
                  if ($utils.isDefined(candidate.row.cells.base_uom_net_weight.editControl.value) && !isNaN(candidate.row.cells.base_uom_net_weight.editControl.value)) {
                      netWeight = Number(candidate.row.cells.base_uom_net_weight.editControl.value);
                  } else {
                      netWeight = 1
                  }
  
  
                  if ($utils.isDefined(candidate.row.cells.base_uom_net_volume.editControl.value) && !isNaN(candidate.row.cells.base_uom_net_volume.editControl.value)) {
                      netVolume = Number(candidate.row.cells.base_uom_net_volume.editControl.value);
                  } else {
                      netVolume = 1
                  }
  
                  if ($utils.isDefined(candidate.row.cells.base_uom_shipping_weight.editControl.value) && !isNaN(candidate.row.cells.base_uom_shipping_weight.editControl.value)) {
                      shippingWeight = Number(candidate.row.cells.base_uom_shipping_weight.editControl.value);
                  } else {
                      shippingWeight = 1
                  }
  
                  if ($utils.isDefined(candidate.row.cells.base_uom_shipping_volume.editControl.value) && !isNaN(candidate.row.cells.base_uom_shipping_volume.editControl.value)) {
                      shippingVolume = Number(candidate.row.cells.base_uom_shipping_volume.editControl.value);
                  } else {
                      shippingVolume = 1
                  }
  
                  var upc = null;
                  if ($utils.isDefined(candidate.row.cells.base_uom_upc.editControl.value)) {
                      upc = candidate.row.cells.base_uom_upc.editControl.value.toString();
                  }
  
                  if ($utils.isDefined(candidate.row.cells.base_uom_pallet_tie.editControl.value)) {
                      PalletTie = candidate.row.cells.base_uom_pallet_tie.editControl.value;
                  }
  
                  if ($utils.isDefined(candidate.row.cells.base_uom_pallet_high.editControl.value)) {
                      PalletHigh = candidate.row.cells.base_uom_pallet_high.editControl.value;
                  }
  
  
  
                  const payloadMaterialPackaging = {
                      "Material": {
  
                          "Id": candidate.row.entity.Id,
                          "ControllerTypeId": ControllerTypeId,
                          "MaterialGroupId": candidate.row.cells.group.editControl.value,
                          "GlobalMaterial": {
  
                              "Id": nextGlobalId,
                              "EnterpriseId": 1,
                              "TypeId": 1,
                              "EligibleForSerialControl": false,
                              "Name": candidate.row.cells.lookupcode.editControl.value,
                              "Description": candidate.row.cells.description.editControl.value,
                              "TransferOptionId": 1
  
                          },
                          "Name": candidate.row.cells.name.editControl.value,
                          "Description": candidate.row.cells.description.editControl.value,
                          "LookupCode": candidate.row.cells.lookupcode.editControl.value,
                          "ProjectId": candidate.row.cells.project.editControl.value,
                          "AllocationStrategyId": candidate.row.cells.allocation_strategy.editControl.value,
                          "StorageCategoryRuleId": candidate.row.cells.storage_category_rule.editControl.value,
                          "IsFixedWeight": fixedWeight,
                          "StatusId": candidate.row.cells.status.editControl.value,
  
                          "KitTypeId": 0, // Set to None
                          "PackageAllocationStrategyId": 3,
                          "CycleCountToleranceOptionId": 0,
                          "ExpirationNotification": false,
                          "DisableNonPreferredLocationAlertCreation": false,
                          "IsFinishedGood": false,
                          "ManufacturingPackagingReview": false,
                          "IsFixedLength": fixedDimension,
                          "IsFixedVolume": fixedVolume,
                          "AutoPopulateVendorLot": true,
                          "AutoPopulateSystemLot": true,
                          "EligibleForScaleTicket": false,
                          "MobileSkipCountBack": false,
                          "TransloadMaterial": false,
                          "ByPassLocationMixingRestrictions": false,
                          "ScanSerialOfAllPackageLevels": false,
                          "DoNotScanSerialsOnRecounts": false,
                          "UseLicensePlateFifoAllocation": false,
                          "ReceiveAsInactive": false,
                          "SkipCycleCount": false,
                          "IsWip": false,
                          "ManufacturingOrdersUseWorstExpirationDate": false,
                          "AllowReceiving": true,
                          "AllowBlindReceiving": true,
                          "AllowShipping": true,
                          "AllowReturns": true,
                          "StandardPrice": 0,
                          "StandardCost": 0,
                          "CurrencyId": 1,
                          "ValuationMethod": ''
  
                      },
                      "PackagingId": candidate.row.cells.base_uom.editControl.value,
                      "IsBasePackaging": true,
                      "SubPackagingQuantity": 0,
                      "BasePackagingId": candidate.row.cells.base_uom.editControl.value,
                      "BasePackagingQuantity": 1,
  
                      "AllowFractions": true,
                      "AllowInSalesOrder": true,
                      "AllowInPurchaseOrder": true,
                      "IsReportingDefault": true,
                      "IsOrderDefault": false,
                      "IsLabelCompliant": false,
                      "UseAsShippingContainer": false,
                      "DeprecatedPackaging": false,
                      "AllowInMobileSales": false,
  
                      "ShippingWeight": shippingWeight,
                      "Weight": netWeight,
                      "TareWeight": 0,
                      "WeightUomId": candidate.row.cells.base_uom_weight_unit.editControl.value,
  
                      "Height": Height,
                      "Width": Width,
                      "Length": Length,
                      "DimensionUomId": candidate.row.cells.base_uom_dimension_unit.editControl.value,
  
                      "Volume": netVolume,
                      "ShippingVolume": shippingVolume,
                      "VolumeUomId": candidate.row.cells.base_uom_volume_unit.editControl.value,
  
                      "PalletTie": PalletTie,
                      "PalletHigh": PalletHigh,
  
                      "UpcCode": upc
  
                  };
  
                  await $flows.Utilities.crud_create_flow({ entitySet: 'MaterialsPackagingsLookup', entity: payloadMaterialPackaging });
  
  
                  candidate.row.refresh();
                  candidate.row.setDisplayMode();
                  candidate.row.isNew = false;
                  // Lock down read only cells upon creation
                  candidate.row.cells.base_uom.editControl.readOnly = true;
                  candidate.row.cells.owner.editControl.readOnly = true;
                  candidate.row.cells.project.editControl.readOnly = true;
                  candidate.row.cells.fixed_dimension.editControl.readOnly = true;
                  candidate.row.cells.fixed_volume.editControl.readOnly = true;
                  candidate.row.cells.fixed_weight.editControl.readOnly = true;
                  candidate.row.cells.serial_controlled.editControl.readOnly = true;
                  candidate.row.cells.lot_controlled.editControl.readOnly = true;
  
  
              }
  
              catch (error) {
                  errors += 'Error calling calling crud Api'
                  candidate.row.cells.error.displayControl.text = errors;
  
                  $grid.topToolbar.linecount.hidden = true;
                  throw error; // to prevent displayMode 
  
              }
  
          }
  
  
      }
  
  }
  
  
  $grid.topToolbar.linecount.hidden = true;
  
  
  /*****************************************************
   * FUNCTIONS
  *****************************************************/
  async function getOwnersPool() {
      let ownerLookupCodes: string[] = Array.from(new Set(Materials.filter(ol => $utils.isDefinedTrimmed(ol.OwnerLookupCode?.toString())).map(ol => ol.OwnerLookupCode?.toString())));
      let index = 0;
  
      while (index < ownerLookupCodes.length) {
          var results = (results || []).concat((await $datasources.ExcelMaterialImport.ds_get_owners_by_lookupcodes.get({
              ownerLookupcodes: ownerLookupCodes.slice(index, index + _batchSize)
          })).result);
  
          index += _batchSize;
      }
  
      return results;
  }
  
  async function getMaterialGroupsPool() {
      let materialGroups: string[] = Array.from(new Set(Materials.filter(ol => $utils.isDefinedTrimmed(ol.Group?.toString())).map(ol => ol.Group?.toString())));
      let index = 0;
  
      while (index < materialGroups.length) {
          var results = (results || []).concat((await $datasources.ExcelMaterialImport.ds_get_materialgroups_by_names.get({ materialGroupNames: materialGroups.slice(index, index + _batchSize) })).result);
          index += _batchSize;
      }
  
      return results
  }
  
  async function getMaterialStatusesPool() {
      let materialStatuses: string[] = Array.from(new Set(Materials.filter(ol => $utils.isDefinedTrimmed(ol.Status?.toString())).map(ol => ol.Status?.toString())));
      let index = 0;
  
      while (index < materialStatuses.length) {
          var results = (results || []).concat((await $datasources.ExcelMaterialImport.ds_get_materialstatuses_by_names.get({ materialStatusNames: materialStatuses.slice(index, index + _batchSize) })).result);
          index += _batchSize;
      }
  
      return results
  }
  
  async function getAllocationStrategiesPool() {
      let allocationStrategies: string[] = Array.from(new Set(Materials.filter(ol => $utils.isDefinedTrimmed(ol.AllocationStrategy?.toString())).map(ol => ol.AllocationStrategy?.toString())));
      let index = 0;
  
      while (index < allocationStrategies.length) {
          var results = (results || []).concat((await $datasources.ExcelMaterialImport.ds_get_material_allocation_strategies_by_name.get({ materialAllocationStrategyNames: allocationStrategies.slice(index, index + _batchSize) })).result);
          index += _batchSize;
      }
  
      return results
  }
  
  async function getStorageCategoriesPool() {
      let storageCategories: string[] = Array.from(new Set(Materials.filter(ol => $utils.isDefinedTrimmed(ol.StorageCategoryRule?.toString())).map(ol => ol.StorageCategoryRule?.toString())));
      let index = 0;
  
      while (index < storageCategories.length) {
          var results = (results || []).concat((await $datasources.ExcelMaterialImport.ds_get_material_storage_category_rules_by_names.get({ materialStorageCategoryRuleNames: storageCategories.slice(index, index + _batchSize) })).result);
          index += _batchSize;
      }
  
      return results
  }
  
  async function getMaterialPackagingsPool() {
      let materialPackagings: string[] = Array.from(new Set(Materials.filter(ol => $utils.isDefinedTrimmed(ol.BaseUom?.toString())).map(ol => ol.BaseUom?.toString())));
      let index = 0;
  
      while (index < materialPackagings.length) {
          var results = (results || []).concat((await $datasources.ExcelMaterialImport.ds_get_materialpackagings_by_shortnames.get({ materialPackagingNames: materialPackagings.slice(index, index + _batchSize) })).result);
          index += _batchSize;
      }
  
      return results
  }
  
  async function getMaterialsPool() {
      let materials: string[] = Array.from(new Set(Materials.filter(ol => $utils.isDefinedTrimmed(ol.LookupCode?.toString())).map(ol => ol.LookupCode?.toString())));
      let index = 0;
  
      while (index < materials.length) {
          var results = (results || []).concat((await $datasources.ExcelMaterialImport.ds_get_materials_by_lookupcodes.get({ materialLookupcodes: materials.slice(index, index + _batchSize) })).result);
          index += _batchSize;
      }
  
      return results
  }
  
  async function getMeasurementUnitsPool() {
      let dimensionUoms: string[] = Array.from(new Set(Materials.filter(ol => $utils.isDefinedTrimmed(ol.BaseUomDimensionUnit?.toString())).map(ol => ol.BaseUomDimensionUnit?.toString())));
      let volumeUoms: string[] = Array.from(new Set(Materials.filter(ol => $utils.isDefinedTrimmed(ol.BaseUomVolumeUnit?.toString())).map(ol => ol.BaseUomVolumeUnit?.toString())));
      let weightUoms: string[] = Array.from(new Set(Materials.filter(ol => $utils.isDefinedTrimmed(ol.BaseUomWeightUnit?.toString())).map(ol => ol.BaseUomWeightUnit?.toString())));
  
      var units = dimensionUoms.concat(weightUoms, volumeUoms);
  
      let index = 0;
  
      while (index < units.length) {
          var results = (results || []).concat((await $datasources.ExcelMaterialImport.ds_get_measurementunits_by_shortnames.get({ measurementUnitShortNames: units.slice(index, index + _batchSize) })).result);
          index += _batchSize;
      }
  
      return results
  }
  
  }
  on_init(event = null) {
    return this.on_initInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_initInternal(
    $grid: ExcelMaterialImport_excel_material_import_gridComponent,
  
    $shell: ExcelMaterialImport_ShellService,
    $datasources: ExcelMaterialImport_DatasourceService,
    $flows: ExcelMaterialImport_FlowService,
    $reports: ExcelMaterialImport_ReportService,
    $settings: SettingsValuesService,
    $operations: ExcelMaterialImport_OperationService,
    $utils: UtilsService,
    $context: ExcelMaterialImport_excel_material_import_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: ExcelMaterialImport_LocalizationService,
    $event: any
  ) {
    this.$logger.log('ExcelMaterialImport', 'excel_material_import_grid.on_init');
  $grid.vars.projectId = 0
  
  $grid.topToolbar.linecount.hidden = true;
  }
  //#endregion private flows

  async $importExcel(fileInput: HTMLInputElement) {
    if(fileInput.files?.length !== 1) {
      throw new Error('Cannot import multiple files');
    }
    const file = fileInput.files[0];
    if(file.size > 15 * 1000 * 1000) {
      throw new Error('Cannot import a file with size greater than 15MB');
    }
    const reader: FileReader = new FileReader();
    reader.onload = async (e: ProgressEvent<FileReader>) => {
      const ab: ArrayBuffer = e.target?.result as ArrayBuffer;
      const wb: WorkBook = readExcelFile(ab);
      await this.on_excel_import(wb);
    };
    reader.readAsArrayBuffer(file);
    fileInput.value = '';
  }

  async $exportExcel() {
    const wb: WorkBook = excelUtils.book_new();

    await this.on_excel_export(wb);

    writeExcelFile(wb, 'ExcelMaterialImport_excel_material_import_gridComponent_export.xlsx');
  }
 
  close() {
    this.$finish.emit();
  }
}
